import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'
import { useDispatch, useSelector } from 'react-redux'

import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import {
  decreaseActiveStepId,
  getInventory,
  getIsFinalStep,
  getIsFirstStep,
  getOldOrderLineSum,
  getOrderTotalCost,
  HW_ORDER_LIMIT,
  increaseActiveStepId,
} from '@/ducks/hardwareReducer'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'

import './order-summary.scss'

const OrderSummary = () => {
  const dispatch = useDispatch()
  const { formatNumber } = useFormattedNumberWithCurrency()

  const orderTotalCost = useSelector(getOrderTotalCost)
  const oldOrderLineSum = useSelector(getOldOrderLineSum)
  const inventory = useSelector(getInventory)

  const isFirstStep = useSelector(getIsFirstStep)
  const isFinalStep = useSelector(getIsFinalStep)

  const isVisible = orderTotalCost > 0
  const isOverLimit = orderTotalCost + oldOrderLineSum > HW_ORDER_LIMIT

  if (inventory.length === 0) return null

  return (
    <div
      className={`order-summary ${isVisible ? 'is-visible' : 'is-not-visible'} ${
        isOverLimit ? 'is-over-limit' : ''
      }`}
    >
      <div className="back">
        {/* @ts-ignore */}
        <button onClick={() => dispatch(decreaseActiveStepId())} disabled={isFirstStep}>
          <ChevronLeftIcon />
          Tilbake
        </button>
      </div>

      <div className="amount">
        <div className="total">
          <FormattedNumberWithCurrency amount={orderTotalCost + oldOrderLineSum} />
        </div>
        <div className="limit">av {formatNumber({ amount: HW_ORDER_LIMIT })} grense</div>
      </div>

      <div className="next">
        <button
          // @ts-ignore
          onClick={() => dispatch(increaseActiveStepId())}
          disabled={isFinalStep || !isVisible || isOverLimit}
        >
          Neste
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  )
}

export default OrderSummary
